import React, { useRef, useEffect, useState } from 'react';
import panelDataSec from './config/panelsLED.json';
import './App.css';
import 'bootstrap';
import './css/custom.css';
import './css/PopupForm.css'; //CSS for the pop-up styling
// js package
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import emailjs from "@emailjs/browser";
// components
import Header from './components/Header';
import Footer from './components/Footer';
import UnitSelection from './components/UnitSelection';
import WallConfiguration from './components/WallConfiguration';
import DisplayConfiguration from './components/DisplayConfiguration';
import LedDisplayoptions from './components/LedDisplayoptions';
import ScreenConfiguration from './components/ScreenConfiguration';
import WallContainer from './components/WallContainer';
import ModalForm from './components/ModalForm';
import useStore from './store/useStore';
import PrintArea from './components/PrintArea';

export default function App() {
  
  const wallWidth = useStore((state) => state.wallWidth);
  const wallHeight = useStore((state) => state.wallHeight);

  const orderNumber = useStore((state) => state.orderNumber);
  const setOrderNumber = useStore((state) => state.setOrderNumber);
  const name = useStore((state) => state.name);
  const email = useStore((state) => state.email);
  const phone = useStore((state) => state.phone);
  const companyName = useStore((state) => state.companyName);

  const projectName = useStore((state) => state.projectName);
  const budget = useStore((state) => state.budget);
  const bid = useStore((state) => state.bid);
  const projectApplication = useStore((state) => state.projectApplication);
  const estimateInstallDate = useStore((state) => state.estimateInstallDate);
  const mount = useStore((state) => state.mount);
  const onsiteCommissioningRequired = useStore((state) => state.onsiteCommissioningRequired);
  const warrantyRequirement = useStore((state) => state.warrantyRequirement);
  const inputResolution = useStore((state) => state.inputResolution);
  const quantityOfInputs = useStore((state) => state.quantityOfInputs);
  const trimRequired = useStore((state) => state.trimRequired);
  
  const [loading, setLoading] = useState(false);
  useEffect(() => emailjs.init(process.env.REACT_APP_EMAILJS_USER_ID), []);
  const componentRef = useRef(null);
  const [showPdfSection, setShowPdfSection] = useState(false);

  // State to control the visibility of the modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to open the modal
  const openModal = () => setIsModalOpen(true);

  // Function to close the modal
  const closeModal = () => setIsModalOpen(false);

  const getOrderNumber = async () => {
    try {
      const response = await fetch(`/get-next-order-number`);

      // Check if response is OK (status in the range 200-299)
      if (!response.ok) {
        throw new Error(`Server error here: ${response.status}`);
      }

      // Ensure the response is JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        throw new Error(`Expected JSON, received: ${text}`);
      }

      const data = await response.json();
      //const orderNumber = data.sequence_value;
      setOrderNumber(data.sequence_value);
      console.log(data.sequence_value);
      console.log("5");
      //const ordernumberRef = data.sequence_value;
    } catch (error) {
      console.error('Error fetching order number:', error);
    }
  };

  const handlePrint = () => {
    return new Promise((resolve, reject) => {
    //Temporarily force the element to a fixed size
    //const originalStyles = componentRef.current.style.cssText; // Save original styles
    componentRef.current.style.width = '1800px';  // Ensure consistent width
    componentRef.current.style.height = 'auto';  // Set auto height for better scaling
    componentRef.current.style.overflow = 'visible';  // Prevent clipping

    // Show the PDF section immediately, if needed
    setShowPdfSection(true);
  
    // Wait for a specific time before capturing the content with html2canvas
    setTimeout(() => {
      html2canvas(componentRef.current).then(canvas => {

        const pdf = new jsPDF('l', 'mm', 'letter'); // 'letter' size is 8.5 x 11 inches
        // Get the page dimensions for the PDF (letter size in landscape mode)
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

         // Get the canvas dimensions and calculate the aspect ratio
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const canvasAspectRatio = canvasWidth / canvasHeight;

        // Calculate image dimensions while maintaining the aspect ratio
        let imgWidth, imgHeight;
        if (canvasAspectRatio > 1) {  // If the canvas is wider than tall
          imgWidth = pageWidth;
          imgHeight = pageWidth / canvasAspectRatio;
        } else {  // If the canvas is taller than wide
          imgHeight = pageHeight;
          imgWidth = pageHeight * canvasAspectRatio;
        }

        const imgData = canvas.toDataURL('image/jpeg');
    
        // Calculate X and Y positions to center the image on the page
        const xPos = (pageWidth - imgWidth) / 2;
        const yPos = (pageHeight - imgHeight) / 2;

        // Add the image to the PDF
        pdf.addImage(imgData, 'JPG', xPos, yPos, imgWidth, imgHeight);
  
        pdf.save(`${projectName}_ProjectID_SBC${orderNumber}`);

        // Convert the PDF to Base64
        const pdfBase64 = pdf.output('datauristring').split(',')[1];  // Remove the data URI prefix;
        //setPdfBase64(pdfBase64);  // Save Base64 string in state
        //console.log('PDF Base64 Length:', pdfBase64.length);
        
        resolve(pdfBase64);  // Return base64 string through Promise
  
        // Optionally, hide the section after another delay, if necessary
        setTimeout(() => setShowPdfSection(false), 2500);
      });
    }, 1000); // This delay waits 1 second before executing html2canvas, adjust as needed
  });
}

  const handleSubmit = async (e, refs) => {
    e.preventDefault();
    // Wait for PDF base64 string to be returned
    const pdfBase64 = await handlePrint();
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId01 = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_01;
    const templateId02 = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_02;

    try {
      setLoading(true);
      await emailjs.send(serviceId, templateId01, {
        ordernumber: orderNumber,
        name: name,
        recipient: email,
        projectname: projectName,
        companyname: companyName,
        phone: phone,
        pixelpitch: `${pixelPitch}`,
        panelarray: `${(maxLEDWidth / panelDetails.panelWidth).toFixed(0)} x ${(maxLEDHeight / panelDetails.panelHeight).toFixed(0)}`,
        timestamp: new Date().toISOString(),
        budget: budget,
        bid: bid,
        projectapplication: projectApplication,
        estimatedinstallationdate: estimateInstallDate,
        mountselection: mount,
        onsitecommissioningrequiredselection: onsiteCommissioningRequired,
        warrantyrequirementselection: warrantyRequirement,
        inputresolutionselection: inputResolution,
        quantityofinputs: quantityOfInputs,
        trimrequired: trimRequired,
      });
      await emailjs.send(serviceId, templateId02, {
        ordernumber: orderNumber,
        name: name,
        recipient: email,
        projectname: projectName,
        companyname: companyName,
        phone: phone,
        pixelpitch: `${pixelPitch}`,
        panelarray: `${(maxLEDWidth / panelDetails.panelWidth).toFixed(0)} x ${(maxLEDHeight / panelDetails.panelHeight).toFixed(0)}`,
        timestamp: new Date().toISOString(),
        budget: budget,
        bid: bid,
        projectapplication: projectApplication,
        estimatedinstallationdate: estimateInstallDate,
        mountselection: mount,
        onsitecommissioningrequiredselection: onsiteCommissioningRequired,
        warrantyrequirementselection: warrantyRequirement,
        inputresolutionselection: inputResolution,
        quantityofinputs: quantityOfInputs,
        trimrequired: trimRequired,
        content: pdfBase64,
        filename: `${projectName}_${orderNumber}.pdf`,
        type: 'application/pdf',
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
    closeModal();
  };

  const [error, setError] = useState('');
  const [errorDisplay, setErrorDisplay] = useState('');

  const [selectedWall, setWall] = useState('Indoor');
  const [product, setProduct] = useState('Crystal');
  const [pixelPitch, setPixelPitch] = useState(0.625);
  const [ledModel, setLedModel] = useState('COB');

  const productOptions = panelDataSec[selectedWall] || [];
  const modualOptions = panelDataSec[selectedWall][product] || [];
  const pixelpitchOptions = panelDataSec[selectedWall][product][ledModel] || [];
  const panelDetails = panelDataSec[selectedWall][product][ledModel][pixelPitch] || [];

  const [maxLEDWidth, setMaxLEDWidth] = useState(panelDetails.panelWidth);
  const [maxLEDHeight, setMaxLEDHeight] = useState(panelDetails.panelHeight);
  
  //calculate final resolutions
  const finalresWidth = (panelDetails.resolutionWidth * (maxLEDWidth / panelDetails.panelWidth)).toFixed(0);
  const finalresHeight = (panelDetails.resolutionHeight * (maxLEDHeight / panelDetails.panelHeight)).toFixed(0);

  const aspectRatio = ((panelDetails.panelWidthmm * maxLEDWidth/panelDetails.panelWidth) / (panelDetails.panelHeightmm * maxLEDHeight/panelDetails.panelHeight));
  const DiagonalDis = (maxLEDWidth * maxLEDWidth) + (maxLEDHeight * maxLEDHeight);
  const overallDistance =((maxLEDWidth + (panelDetails.frameSize * 2 * 0.00328)) * (maxLEDWidth + (panelDetails.frameSize * 2 * 0.00328))) + ((maxLEDHeight + (panelDetails.frameSize * 2 * 0.00328)) * (maxLEDHeight + (panelDetails.frameSize * 2 * 0.00328)));

  const wallAspectRatio = (wallWidth / wallHeight).toFixed(2);

  // Calculate dynamic width and height based on aspect ratio
  const wallContainerWidth = wallAspectRatio >= 1 ? '275' : `${wallAspectRatio * 275}`;  //origon 480
  const wallContainerHeight = wallAspectRatio < 1 ? '275' : `${275 / wallAspectRatio}`;

  return (
    <div><Header /><div/>
    <div>
      {isModalOpen && (
        <ModalForm
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        handleSubmit={handleSubmit}
        loading={loading}
      />
      )}
    </div>

    <div className="container" id="report"> 
      <h2 className="text-center mb-5 mt-5" id="h2-text">SBC dvLED Configurator</h2>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-0">
           <UnitSelection />
           <WallConfiguration
              maxLEDWidth={maxLEDWidth}
              maxLEDHeight={maxLEDHeight}
              setMaxLEDWidth={setMaxLEDWidth}
              setMaxLEDHeight={setMaxLEDHeight}
              panelDetails={panelDetails}
              error={error}
              setError={setError}
           />
           <DisplayConfiguration
              maxLEDWidth={maxLEDWidth}
              maxLEDHeight={maxLEDHeight}
              setMaxLEDWidth={setMaxLEDWidth}
              setMaxLEDHeight={setMaxLEDHeight}
              panelDetails={panelDetails}
              setError={setError}
              errorDisplay={errorDisplay}
              setErrorDisplay={setErrorDisplay}
            />
            <LedDisplayoptions
              selectedWall={selectedWall}
              product={product}
              pixelPitch={pixelPitch}
              ledModel={ledModel}
              productOptions={productOptions}
              modualOptions={modualOptions}
              pixelpitchOptions={pixelpitchOptions}
              setMaxLEDHeight={setMaxLEDHeight}
              setWall={setWall}
              setProduct={setProduct}
              setLedModel={setLedModel}
              setPixelPitch={setPixelPitch}
            />
            <div className="row mt-4 mb-5 text-center">
              <div className="col-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <a href="https://hd2pro.com/contact/" target="_blank" rel="noreferrer"><button className="btn" id="btn-info-nav">Contact Us</button></a>
              </div>
              <div className="col-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <button className="btn" id="btn-info-nav" onClick={() => {
                                                                      openModal();   // First function to open modal
                                                                      getOrderNumber();  // Second function to get the order number
                                                                    }}
                >Export to PDF</button>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
              <WallContainer
                maxLEDWidth={maxLEDWidth}
                maxLEDHeight={maxLEDHeight}
                wallContainerWidth={wallContainerWidth}
                wallContainerHeight={wallContainerHeight}
                panelDetails={panelDetails}
              />
              <ScreenConfiguration
                maxLEDWidth={maxLEDWidth}
                maxLEDHeight={maxLEDHeight}
                panelDetails={panelDetails}
                finalresWidth={finalresWidth}
                finalresHeight={finalresHeight}
                aspectRatio={aspectRatio}
                DiagonalDis={DiagonalDis}
                overallDistance={overallDistance}
              /><div><span className="star-mark">*</span>Power consumption may vary based on brightness settings and is for reference only.</div>
          </div>
        </div>
        <Footer />
      </div>
      {/* need to hide this section but also need it to be seen by jsPDF. so I have a state can help adjust the visibility of the print section */}
      <div className={`print-container ${showPdfSection ? '' : 'hidden'}`} ref={componentRef}>
        <PrintArea
          maxLEDWidth={maxLEDWidth}
          maxLEDHeight={maxLEDHeight}
          pixelPitch={pixelPitch}
          ledModel={ledModel}
          orderNumber={orderNumber}
        />
      </div>
    </div>
  );
}